import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';

interface ConsumptionBarChartProps {
  months: string[];
  datos: { year: number; month: number; total_fuel_used: number }[];
  height?: number;
  tooltipLabel?: string;
}

export const ConsumptionBarChart: React.FC<ConsumptionBarChartProps> = ({ months, datos, height = 280, tooltipLabel = 'total_fuel_used' }) => {
  const chartData = months.map((month, idx) => {
    const d = datos.find(e => e.month === idx + 1);
    return {
      name: month,
      total_fuel_used: d && d.total_fuel_used ? parseFloat(d.total_fuel_used.toFixed(2)) : 0
    };
  });

  return (
    <div className="w-full">
       {/*  <div>{datos.total_fuel_used}</div> */}
      <ResponsiveContainer width="100%" height={height}>
        <BarChart data={chartData} margin={{ top: 16, right: 24, left: 8, bottom: 16 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="name"
            height={48}
            tick={props => {
              const { x, y, payload } = props;
              return (
                <text
                  x={x}
                  y={y + 16}
                  transform={`rotate(-35,${x},${y + 16})`}
                  fontSize={12}
                  textAnchor="end"
                  fill="#334155"
                  fontWeight={'bold'}
                >
                  {payload.value}
                </text>
              );
            }}
          />
          <YAxis tick={{ fontSize: 12 }} />
          <Tooltip formatter={(value: any) => [`${value} L`, tooltipLabel]} />
          <Bar dataKey="total_fuel_used" fill="#38bdf8" radius={[6, 6, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ConsumptionBarChart;
